import { useEffect } from 'react';

import * as userStore from '@cartwhl/common/stores/userStore';

const FORM_TAG_NAMES = new Set(['INPUT', 'SELECT', 'TEXTAREA']);

/** Toggles the persisted color theme with Shift + L. */
export default function useThemeHotkey() {
  useEffect(() => {
    userStore.setTheme(userStore.state.theme);

    const handleKeyDown = (event: KeyboardEvent) => {
      const target = event.target;
      const isEditableTarget =
        target instanceof HTMLElement &&
        (target.isContentEditable || FORM_TAG_NAMES.has(target.tagName));

      if (
        event.repeat ||
        event.altKey ||
        event.ctrlKey ||
        event.metaKey ||
        !event.shiftKey ||
        event.key.toLowerCase() !== 'l' ||
        isEditableTarget
      ) {
        return;
      }

      event.preventDefault();
      userStore.setTheme(userStore.state.theme === 'dark' ? 'light' : 'dark');
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);
}
